exports.post = {
    path: '/login',
    name: 'login', 
    component: () =>{
        return import("@/views/main/Login.vue") 
    }
}